import { render } from "./ShortcutComponent.vue?vue&type=template&id=3633b2b4&scoped=true"
const script = {}

import "./ShortcutComponent.vue?vue&type=style&index=0&id=3633b2b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3633b2b4"]])

export default __exports__